import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

import { IVendorCompanyMast } from "../../../models/VendorCompanyMast";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { JVInput } from "../../../shared/JVInput";
import { JVDropdown } from "../../../shared/JVDropdown";
import { ICityMastDropdown, IPartnerCategoryDropdown, IStateMastDropdown } from "../../../models/IDropdown";
// import { IVendorTypeMastDropdown } from "../../../models/IDropdown";
import { JVDropdownInput } from "../../../shared/JVDropdownInput";
import { EmptyVendorCompany } from "./EmptyVendorCompany";
import { JVInputMask } from "../../../shared/JVInputMask";
// import { JVCheckbox } from "../../../shared/JVCheckbox";
import { ILogin } from "../../../models/Login";

const schema = yup.object({
  vendor_Company_Name: yup.string().required("Company Name is required*").min(3),
  vendor_Company_FidNo: yup.string(),
  vendor_Company_Phone: yup.string().required("Phone No is required*"),
  vendor_Company_Phone1: yup.string(),
  vendor_Company_FaxNo: yup.string(),
  client_Category_ID: yup.number().min(1, "Client Category is required*").required("Client Category is required*"),
  // service_Department: yup.string().required("Service Department is required*"),
  service_Department: yup.string().nullable(),
  // street_Address: yup.string().required("Street Address is required*"),
  street_Address: yup.string().nullable(),
  // state: yup.object().shape({
  //   state_ID: yup.number().min(1, "State is required*").required("State is required*"),
  //   state_Name: yup.string().required(),
  // }),
  // city: yup.object().shape({
  //   city_ID: yup.number().min(1, "City is required*").required("City is required*"),
  //   city_Name: yup.string().required(),
  // }),
  website_URL: yup.string().required().url(),
});

interface Iprops {
  singleData: IVendorCompanyMast;
  open: boolean;
  hideDialog: () => void;
  toast: any;
  reload: boolean;
  setReload: (is: boolean) => void;
}

export const Form = (props: Iprops) => {
  const [loading, setLoading] = useState(false);
  const [states, setStates] = useState<Array<IStateMastDropdown>>();
  const [cities, setCities] = useState<Array<ICityMastDropdown>>();
  const [clientCategories, setClientCategories] = useState<any[]>([]);
  const [showForStateCat, setShowForStateCat] = useState<boolean>(false);
  const [showForFederalCat, setShowForFederalCat] = useState<boolean>(false);
  //   const [isDisablePV, setIsDisablePV] = useState(false);
  //   const [partnerCategory, setPartnerCategory] = useState<Array<IPartnerCategoryDropdown>>();

  const { control, handleSubmit, formState: { errors, isDirty }, reset, watch } = useForm<IVendorCompanyMast>({
    resolver: yupResolver(schema),
    defaultValues: {
      vendor_Company_ID: undefined,
      vendor_Company_Name: "",
      vendor_Type: 5,
      vendor_Type_Name: "",
      vendor_Company_FidNo: "",
      vendor_Company_Phone: "",
      vendor_Company_Phone1: "",
      vendor_Company_FaxNo: "",
      street_Address: "",
      city_ID: 0,
      city_Name: "",
      city: {
        city_ID: 0,
        city_Name: "",
      },
      state_ID: 0,
      state_Name: "",
      state: {
        state_ID: 0,
        state_Name: "",
      },
      website_URL: "",
      major_Technology: "",
      added_By_User: 0,
      category: 0,
      client_Category_ID: 0,
      service_Department: "",
    },
    shouldFocusError: false,
  });

  const _roles: Array<number> = [];
  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  loginObj.roles.forEach((role: { role_ID: number }) => {
    _roles.push(role.role_ID);
  });

  useEffect(() => {
    reset(props.singleData);
  }, [props.singleData]);

  const loadCities = async (filter: string | null) => {
    if (control._formValues.state?.state_ID) {
      const response = await Fetch("Dropdown/cities", "GET", null, `filter=${filter}&state_id=${control._formValues.state.state_ID}`, null);
      if (response) {
        const data: Array<ICityMastDropdown> = await response.json();
        setCities(data);
      }
    } else {
      props.toast.current.show({ severity: "error", detail: "Select the State First.", life: 3000 });
    }
  };
  const completeMethodCities = (event: { query: string }) => {
    loadCities(event.query);
  };

  const loadStates = async (filter: string | null) => {
    const response = await Fetch("Dropdown/states", "GET", null, `filter=${filter}`, null);
    if (response) {
      const data: Array<IStateMastDropdown> = await response.json();
      setStates(data);
    }
  };
  // const completeMethodStates = (event: { query: string }) => {
  //   loadStates(event.query);
  // };

  const loadClientCategories = async () => {
    const response = await Fetch("Tender_Client_Category/TenderClientCategoryDropdown", "GET", null, null, null);

    if (response?.ok) {
      const data = await response.json();
      setClientCategories(data.filter((el: any) => !el.category_Name.includes("Private")));
    }
  };

  useEffect(() => {
    loadClientCategories();
  }, []);

  const saveToDB = async (body: IVendorCompanyMast) => {
    setLoading(true);
    const method = props.singleData.vendor_Company_ID ? "PUT" : "POST";
    const message = props.singleData.vendor_Company_ID ? "Updated Successfully" : "Added Successfully";
    body.state_ID = body.state?.state_ID;
    body.city_ID = body.city?.city_ID;
    delete body.state;
    delete body.city;
    const isEdit = !!props.singleData.vendor_Company_ID;

    const response = await Fetch(isEdit ? "Tender_Client_Category/UpdateClient" : "Tender_Client_Category/AddTenderClient", isEdit ? "PUT" : "POST", body, null, props.toast);
    if (response) {
      props.hideDialog();
      props.toast.current.show({ severity: "success", detail: message, life: 3000 });
      props.setReload(!props.reload);
    }
    setLoading(false);
  };

  const onHide = () => {
    props.hideDialog();
    reset(EmptyVendorCompany);
  };

  function onSubmit(data: IVendorCompanyMast) {
    data.vendor_Type = 5;
    saveToDB(data);
  }

  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      if (name === "client_Category_ID") {
        if (value.client_Category_ID === 1) { // State Client
          setShowForStateCat(true);
          setShowForFederalCat(false);
        } else if (value.client_Category_ID === 3) { // Federal  Client
          setShowForStateCat(false);
          setShowForFederalCat(true);
        }
      }
    });
    return () => subscription.unsubscribe();
  }, [watch, showForStateCat, showForFederalCat]);

  return (
    <Dialog visible={props.open} style={{ width: "80vw" }} header="Add/Edit State/Federal Client" modal className="p-fluid" onHide={onHide}>
      <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
        <JVDropdown column={3} required label="Client Category" control={control} name="client_Category_ID" error={errors.client_Category_ID?.message} options={clientCategories} optionLabel="category_Name" optionValue="id" placeholder="Select Client Category" />
        <JVInput column={3} required label="Company Name" control={control} name="vendor_Company_Name" error={errors.vendor_Company_Name?.message} />
        {/* {showForStateCat && <JVInput column={3} label="FID#" control={control} name="vendor_Company_FidNo" error={errors.vendor_Company_FidNo?.message} />} */}
        <JVInputMask column={3} mask="(999) 999-9999" required label="Phone No" control={control} name="vendor_Company_Phone" error={errors.vendor_Company_Phone?.message} />
        <JVInputMask column={3} mask="(999) 999-9999" label="Alternate Phone No" control={control} name="vendor_Company_Phone1" error={errors.vendor_Company_Phone1?.message} />
        <JVInput column={3} label="Fax No." control={control} name="vendor_Company_FaxNo" error={errors.vendor_Company_FaxNo?.message} />
        {/* {showForStateCat && <JVInput column={3} required label="Street Address" control={control} name="street_Address" error={errors.street_Address?.message} />} */}
        {/* {showForStateCat && <JVInput column={3} required label="Service Department" control={control} name="service_Department" error={errors.service_Department?.message} />} */}

        {/* {showForStateCat && <JVDropdownInput column={3} required completeMethod={completeMethodStates} label="State" control={control} name="state" error={errors.state?.state_ID?.message} options={states} optionLabel="state_Name" placeholder="Search State" />} */}
        {/* {showForStateCat && <JVDropdownInput column={3} required completeMethod={completeMethodCities} label="City" control={control} name="city" error={errors.city?.city_ID?.message} options={cities} optionLabel="city_Name" placeholder="Search City" />} */}

        <JVInput column={3} required label="Website Url(http://www.domainname.com)" control={control} name="website_URL" error={errors.website_URL?.message} />
        <div style={{ marginBottom: "20px", width: "100%" }}></div>

        <div className="col-12 md:col-12 flex gap-4 justify-content-end">
          <Button loading={loading} style={{ width: "100px" }} label="SAVE" type="submit" disabled={!isDirty}></Button>
          <Button style={{ width: "100px" }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200		"></Button>
        </div>
      </form>
    </Dialog>
  );
};
